<template>
  <div class="sun not-full main b-F4FAFF pt-30px pb-30px f-16px lh-24px">
    <!--동의-->
    <div :class="{'mt-20px':index>0}" v-for="(agreement, index) in agreements" :key="'Agreement'+index">
      <div class="title">
        {{agreement.title}}
      </div>
      <div class="textbox mt-10px" :class="{'active':agreement.is_agreed}">
        {{agreement.description}}
      </div>
      <div class="mt-10px agree">
        {{agreement.label_btn}}
        <button class="agreebtn"
                :class="{'active':agreement.is_agreed}"
                @click="clickAgreement(agreement)">
          {{agreement.text_btn}}
        </button>
      </div>
    </div>
    <!--이율-->
    <div class="mt-20px rate" v-for="(rate, index) in rates" :key="'Rate'+index">
      <div class="title">{{rate.title}}</div>
      <div class="description mt-6px">
        {{rate.text_description}}
      </div>
      <div class="w-100 mt-10px">
        <div class="inputbox f-l mr-8px" @click="clickDayInput(index)">
          <span class="label">일</span>
          <span class="unit">%</span>
          <div class="input">
            <span :style="{'opacity': rate.day_input && rate.day_input==rate.day ? '0':'100',}">{{rate.day}}</span>
            <input type="number"
                   ref="day_inputs"
                   @input="checkRate(rate)"
                   v-model="rate.day_input"
                   :style="{
                     'color': rate.day_input==rate.day ? '#1baaf1':'#333333',
                     'font-weight': rate.day_input==rate.day ? 600:500}"/>
          </div>
        </div>
        <div class="inputbox f-l" @click="clickYearInput(index)">
          <span class="label">연</span>
          <span class="unit">%</span>
          <div class="input year">
            <span :style="{'opacity': rate.day_input && rate.year_input==rate.year ? '0':'100',}">{{rate.year}}</span>
            <input type="number"
                   ref="year_inputs"
                   @input="checkRate(rate)"
                   v-model="rate.year_input"
                   :style="{
                     'color': rate.year_input==rate.year ? '#1baaf1':'#333333',
                     'font-weight': rate.year_input==rate.year ? 600:500}"/>
          </div>
        </div>
      </div>
      <div class="description2 mt-8px">
        {{rate.text_description2}}
      </div>
      <div class="caution">
        {{rate.text_caution}}
      </div>
    </div>
  </div>
</template>

<script>
let self

export default {
  name: 'DocumentLoanInput',
  components: {},
  props: ['isAgreed', 'offer'],
  data: function () {
    return {
      agreements: [
        {
          title: '대출 실행 금액',
          description: '카드매출에 의해 자동 산정 (비상금 서비스의 경우 웹페이지/앱상에서 차주가 신청한 금액)',
          label_btn: '대출 실행 금액에 대한 내용에',
          text_btn: '동의함',
          is_agreed: false
        }, {
          title: '변제 기간',
          description: '매 건 별 지급일로부터 카드결제대금 상환일까지 ( 비상금서비스의 경우 차주 신청시 회사가 웹/앱 상에서 안내한 기간 )',
          label_btn: '변제 기간 대한 내용에',
          text_btn: '동의함',
          is_agreed: false
        }
      ],
      rates: [
        {
          title: '정상이율',
          day: 0,
          year: 0,
          is_agreed: false
        }, {
          title: '부대비용',
          day: 0,
          year: 0,
          text_description: '중도상환 수수료 : 없음, 플랫폼 수수료 :',
          text_description2: '는 별도 부담',
          is_agreed: false
        },
      ],
    }
  },
  computed: {},
  async created() {
    self = this
    self.setRates()
    if (self.isAgreed) {
      self.agreeRates()
      self.agreeAgreements()
    }
  },
  destroyed() {},
  methods: {
    agreeRates() {
      for (let rate of this.rates) {
        rate.day_input = rate.day
        rate.year_input = rate.year
        rate.is_agreed = true
      }
    },
    agreeAgreements() {
      for (let agreement of this.agreements) {
        agreement.is_agreed = true
      }
    },
    setRates() {
      if (this.offer.interest_rate) {
        this.rates[0].year = (this.offer.interest_rate * 100).toFixed(1)
        this.rates[0].day = (this.rates[0].year / 365).toFixed(4)
      }

      if (this.offer.fee_rate) {
        this.rates[1].year = (this.offer.fee_rate * 100).toFixed(1)
        this.rates[1].day = (this.rates[1].year / 365).toFixed(4)
      }
    },
    clickDayInput(index) {
      this.$refs.day_inputs[index].focus()
    },
    clickYearInput(index) {
      this.$refs.year_inputs[index].focus()
    },
    checkRate(rate) {
      let isSameDay = Number(rate.day_input) === Number(rate.day)
      let isSameYear = Number(rate.year_input) === Number(rate.year)
      if (isSameDay && isSameYear) {
        rate.is_agreed = true
      } else {
        rate.is_agreed = false
      }
      this.checkAll()
    },
    clickAgreement(agreement) {
      agreement.is_agreed = !agreement.is_agreed
      this.checkAll()
    },
    checkAll() {
      let isAgreedAgreements = this._.every(this.agreements, 'is_agreed')
      let isAgreedRates = this._.every(this.rates, 'is_agreed')
      if (isAgreedAgreements && isAgreedRates) {
        this.$emit('agree')
      } else {
        this.$emit('disagree')
      }
    },
    maxLengthCheck(object) {
      if (object.value.length > object.maxLength) {
        object.value = object.value.slice(0, object.maxLength)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

  .main {
    margin-top: 30px;
    .title {
      font-weight: 600;
    }

    .textbox {
      font-size: 16px;
      line-height: 1.38;
      color: #8a94a2;
      padding: 15px 20px;
      border: solid 1px #d7e1ea;
      border-radius: 4px;
      background: white;

      &.active {
        color: #1baaf1;
        font-weight: 600;
      }
    }

    .rate {
      width: 100%;

      .description, description2 {
        width: 100%;
        font-size: 15px;
        line-height: 1.53;
        letter-spacing: -0.2px;
      }

      .inputbox {
        display: inline-block;
        width: calc(50% - 8px);
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        background-color: #ffffff;

        padding-left: 15px;
        padding-right: 15px;

        .label {
          float: left;
        }
        .input {
          display: inline-block;
          margin-right: 4px;
          text-align: left;
          line-height: 48px;
          height: 48px;
          float: right;
          span {
            display: inline-block;
            height: 100%;
            text-align: left;
            color: #8a94a2;
            font-weight: 400;
            z-index: 1;
          }
          input {
            display: inline-block;
            position: absolute;
            min-width: 200%;
            height: 100%;
            top: 0;
            left: 0;
            padding: 0;
            background: none;
            z-index: 2;
            overflow: visible;
          }
        }
        .unit {
          float: right;
        }

        div, span, input {
          display: inline-block;
        }
      }

      .caution {
        font-size: 15px;
        line-height: 1.53;
        letter-spacing: -0.2px;
        color: #727d8c;
      }
    }

    .agree {
      width: 100%;
      font-size: 15px;
      line-height: 48px;
      font-weight: 600;

      .agreebtn, .agreebtn:hover {
        float: right;
        width: 80px;
        height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        font-size: 15px;
        line-height: 1.6;
        color: #727d8c !important;
        background-color: white !important;
        &.active, &.active:hover {
          color: #1baaf1 !important;
          background-color: white !important;
          font-weight: 600;
        }
      }

    }
  }
</style>
